import { render, staticRenderFns } from "./meetingRoomPopover.vue?vue&type=template&id=5a84f882&scoped=true&"
import script from "./meetingRoomPopover.vue?vue&type=script&lang=js&"
export * from "./meetingRoomPopover.vue?vue&type=script&lang=js&"
import style0 from "./meetingRoomPopover.vue?vue&type=style&index=0&id=5a84f882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84f882",
  null
  
)

export default component.exports